import { useContext } from "react";

import type { ProjectDetailsContextType } from "./ProjectDetailsContext";

import { ProjectDetailsContext } from "./ProjectDetailsContext";

export function useProjectDetails(): ProjectDetailsContextType {
  const context = useContext(ProjectDetailsContext);

  if (!context) {
    throw new Error(
      "useProjectDetails must be used within a ProjectDetailsProvider",
    );
  }

  return context;
}
